import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { cloneDeep } from 'lodash';
import AddFilterItemDialog from './addFilterItemDialog';
import style from './style.vue';
import { IPSService } from '@/services/ipsServices';
import { noop, QinggerLibUtils } from '@/util';
import Utils from '@/library/utils';
const isset = QinggerLibUtils.isset;

interface FilterItem {
  classId?: number;
  className?: string;
  classSort?: number;
  classState?: 0 | 1; // 状态 0禁用 1启用
  parentId?: number;
  relationClass?: string[];
  relationList?: string[];
  children?: ChildrenItem[];
}

interface ChildrenItem {
  classId?: number;
  className?: string;
  classSort?: number;
  classState?: 0 | 1; // 状态 0禁用 1启用
  parentId?: number;
  relationClass?: string[];
  children?: ChildrenItem[];
  relationList?: { attrCode?: string; attrName?: string; attrValues?: string }[];
}

@Component({
  mixins: [style],
})
export default class FilterItemManager extends Vue {
  dataList: FilterItem[] = [];

  loadingState = false;

  sgId = 0;

  tableData: ItemArray = [];

  attrbuteList = [];

  mode = 0;

  async mounted() {
    this.mode = +this.$route.params.mode;
    this.sgId = +this.$route.params.id || +this.$route.params.sgId;
    this.attrbuteList = await this.getAttributeList();
    let tableData = [];
    this.attrbuteList.forEach((v) => {
      tableData.push({
        ...v,
        levels: 0,
        title: v.attrName || v.value_name,
        value_no: v.attrCode,
        expanded: false,
      });
      tableData = tableData.concat(this.treeToArray(v.children || []).flat(100));
    });
    this.tableData = tableData;
    this.getData();
  }

  treeToArray(val) {
    return val.map((v) => {
      let result = [];
      result = result.concat([
        {
          ...v,
          title: v.attrName || v.value_name,
          value_no: v.value_no,
          expanded: false,
          parent_no: v.parent_no || v.class_code,
        },
      ]);
      if (v.children && v.children.length) {
        result = result.concat(this.treeToArray(v.children));
      }
      return result;
    });
  }

  /**
   * 网点组获取关联分类
   * @param null
   * @return {Promise<any>}
   */
  public getAttributeList(): Promise<any> {
    return IPSService.productAttrList().then((res) => {
      return isset(res, 'list') ? res.list : [];
    });
  }

  /**
   * 行样式 控制显示和不显示
   * @param row
   * @returns {string}
   */
  showTr({ row }): string {
    const show = row._parent ? row._parent._expanded && row._parent._show : true;
    row._show = show;
    return show ? '' : 'display:none;';
  }

  /**
   * 单元格样式 控制显示和不显示
   * @param row
   * @returns {string}
   */
  showCell({ row }): string {
    const show = row._parent ? row._parent._expanded && row._parent._show : true;
    row._show = show;
    return show ? '' : 'display:none;';
  }

  /**
   * 行样式 控制显示和不显示
   * @param null
   * @returns null
   */
  getData(): void {
    this.loadingState = true;
    IPSService.classFilterList({
      postParams: {
        sgId: this.sgId,
      },
    }).then(
      (response) => {
        this.loadingState = false;
        const list = cloneDeep(Utils.MSDataTransfer.treeToArray(response.list, null, null, false));
        if (!this.dataList || !this.dataList.length) {
          this.dataList = list;
        } else {
          this.dataList = list.map((v) => {
            const find: ItemObject = this.dataList.find(val => val.classId === v.classId);
            if (find) {
              v.isEditing = find.isEditing;
              v.isHovered = find.isHovered;
              v.parentId = find.parentId;
              v._expanded = find._expanded;
              v._level = find._level;
              v._show = find._show;
            }
            return v;
          });
        }
      },
      () => {
        this.loadingState = false;
      },
    );
  }

  /**
   * 编辑此分类
   * @param id
   * @returns null
   */
  onEdit(classId: number, parentId: number, val): void {
    const parentName = parentId ? this.dataList.find(v => v.classId === parentId).className : '';
    AddFilterItemDialog.open({
      title: '编辑筛选项',
      classId,
      parentName,
      addType: parentId ? 2 : 1,
      sgId: this.sgId,
      tableData: this.tableData,
    }).then((result) => {
      this.getData();
    }, noop);
  }

  /**
   * 为此分类新增下级
   * @param id
   * @returns null
   */
  onAddChildren(parentId, vAttributeValue: string): void {
    const tableData = this.tableData.filter(v => v.parent_no === vAttributeValue);
    AddFilterItemDialog.open({ title: '新增下级', addType: 2, sgId: this.sgId, tableData, parentId }).then((result) => {
      this.getData();
    }, noop);
  }

  /**
   * 禁用或启用该分类
   * @param {number} id
   * @param {number} classState 0 禁用 1 启用
   * @returns null
   */
  onUpdateState(id: number, classState: 0 | 1): void {
    classState ? this.onEnable(id) : this.onDisabled(id);
  }

  /**
   * 启用
   * @param {number} classId
   * @returns null
   */
  onEnable(classId: number): void {
    IPSService.classFilterStateChange({
      postParams: {
        classId,
        openState: 1,
      },
    }).then((response) => {
      this.$message.success('操作成功');
      this.getData();
    });
  }

  /**
   * 禁用
   * @param {number} classId
   * @returns null
   */
  onDisabled(classId: number): void {
    this.$confirm('确定禁用该筛选项?', { type: 'warning' }).then((result) => {
      if (result === 'confirm') {
        IPSService.classFilterStateChange({
          postParams: {
            classId,
            openState: 0,
          },
        }).then((response) => {
          this.$message.success('操作成功');
          this.getData();
        });
      }
    }, noop);
  }

  /**
   * 移除该分类
   * @param classId
   * @returns null
   */
  onRemove(classId: number, parentId: number): void {
    this.$confirm(`${parentId ? '' : '其从属二级将同步删除,'}确定移除该筛选项?`, { type: 'warning' }).then((result) => {
      if (result === 'confirm') {
        IPSService.classFilterStateDelete({
          postParams: {
            classId,
          },
        }).then((response) => {
          this.$message.success('操作成功');
          this.getData();
        });
      }
    }, noop);
  }

  /**
   * 输入框失焦排序
   * @param val
   * @param classId
   * @param parentId 1 一级排序 2 二级排序
   * @returns null
   */
  onBlurSort(val): void {
    if (!val.classSort || !Number(val.classSort)) {
      this.$message.warning('请输入序号');
      return;
    }
    if (val.classSort > 5000 || Number(val.classSort) > 5000) {
      this.$message.warning('序号最大5000');
      return;
    }
    IPSService.classFilterSave({
      postParams: {
        sgId: this.sgId,
        className: val.className,
        classSort: Number(val.classSort),
        vAttributeValue: val.vAttributeValue,
        classId: val.classId,
      },
    }).then((response) => {
      this.$message.success('操作成功');
      this.getData();
    });
  }

  /**
   * 添加一级筛选项
   * @param null
   * @returns null
   */
  onAddFilterItem(): void {
    AddFilterItemDialog.open({ sgId: this.sgId, tableData: this.tableData }).then((result) => {
      this.getData();
    }, noop);
  }

  /**
   * 点击展开和关闭的时候，图标的切换
   * @param {ItemObject} record
   * @return {boolean}
   */
  public toggleIconShow(record: ItemObject): boolean {
    return record.children && record.children.length > 0;
  }

  /**
   * 展开下级
   * @param trIndex
   */
  public expandLevel(trIndex) {
    const record: ItemObject = this.dataList[trIndex];
    record._expanded = !record._expanded;
    this.$forceUpdate();
  }

  relationClassName(vAttributeValue: string): string {
    const classItem = this.tableData.find(v => v.value_no === vAttributeValue);
    return classItem ? classItem.title : '/';
  }

  renderTableBtn(h, val) {
    const { classId, classState, parentId = 0, vAttributeValue } = val;
    return (
      <div>
        <span class="scopeSpan" onClick={this.onEdit.bind(this, classId, parentId, val)}>
          编辑
        </span>
        {!parentId && (
          <span class="scopeSpan" onClick={this.onAddChildren.bind(this, classId, vAttributeValue)}>
            新增下级
          </span>
        )}
        <span class="scopeSpan" onClick={this.onUpdateState.bind(this, classId, classState ? 0 : 1)}>
          {classState ? '禁用' : '启用'}
        </span>
        <span class="scopeSpan" onClick={() => this.onRemove(classId, parentId)}>
          删除
        </span>
      </div>
    );
  }

  render(h) {
    return (
      <div class="filter-item-list">
        <div class="messageBlock">
          <span class="redText">*&nbsp;</span>
          {this.mode === 2 ? '筛选项将应用于商品列表中对商品的筛选，请基于商品的主档分类配置筛选项，云店中的商品分类配置将基于该筛选项进行配置' : '筛选项将用于商品列表的筛选，若不配置将默认使用商品分类管理中配置的分类作为筛选项'}
        </div>
        <el-table v-loading={this.loadingState} data={this.dataList} element-loading-text="加载中" height={this.$store.state.windowHeight - 264} ref="table" tooltip-effect="light" row-style={this.showTr} cell-style={this.showCell}>
          <el-table-column
            label="筛选项名称"
            prop="className"
            show-overflow-tooltip
            {...{
              scopedSlots: {
                default: (scoped) => {
                  return (
                    <div>
                      {this.toggleIconShow(scoped.row) && (
                        <div class="tableExpandBtn" onClick={this.expandLevel.bind(this, scoped.$index)}>
                          {!scoped.row._expanded && <i class="el-icon-caret-right" aria-hidden="true" />}
                          {scoped.row._expanded && <i class="el-icon-caret-bottom" aria-hidden="true" />}
                        </div>
                      )}
                      <div style={{ paddingLeft: scoped.row.parentId ? '48px' : '32px' }}>{scoped.row.className}</div>
                    </div>
                  );
                },
              },
            }}
          />
          <el-table-column
            label="排序"
            prop="classSort"
            align="center"
            show-overflow-tooltip
            {...{
              scopedSlots: {
                default: (scoped) => {
                  return <el-input type="number" v-model={scoped.row.classSort} min={1} max={5000} class="sortInput" onBlur={this.onBlurSort.bind(this, scoped.row, scoped.row.classId, scoped.row.parentId ? 2 : 1)} />;
                },
              },
            }}
          />
          <el-table-column
            label="关联分类"
            prop="vAttributeValue"
            show-overflow-tooltip
            {...{
              scopedSlots: {
                default: (scoped) => {
                  return <span>{this.relationClassName(scoped.row.vAttributeValue)}</span>;
                },
              },
            }}
          />
          <el-table-column
            label="状态"
            align="center"
            show-overflow-tooltip
            {...{
              scopedSlots: {
                default: (scoped) => {
                  return <span>{scoped.row.classState ? '启用' : '禁用'}</span>;
                },
              },
            }}
          />
          <el-table-column
            label="操作"
            align="center"
            show-overflow-tooltip
            {...{
              scopedSlots: {
                default: (scoped) => {
                  return this.renderTableBtn(h, scoped.row);
                },
              },
            }}
          />
        </el-table>
        <div class="bottomWrapper">
          <el-button type="primary" onClick={this.onAddFilterItem.bind(this)}>
            添加一级筛选项
          </el-button>
        </div>
      </div>
    );
  }
}
